import React from "react"
import { Popover, Divider, Grid, Button } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import { NavLink } from "react-router-dom"
import NotificationList from "../NotificationList"
import { useMutationReadNotification } from "../../data"

const usePopoverStyles = makeStyles(() => ({
  root: {
    width: 380,
    maxHeight: "85vh",
  },
  paper: {
    width: "100%",
    maxWidth: "calc(100vw - 32px)",
  },
}))

const useStyles = makeStyles((theme) => ({
  header: {
    padding: "12px 24px",
    fontWeight: "600",
    fontSize: "16px",
  },
  linkButton: {
    color: theme.palette.primary.main,
    fontSize: "14px",
    fontWeight: "600",
    "&:hover": {
      textDecoration: "none",
    },
  },
  notifications: {},
  footer: {
    backgroundColor: "#fafafa",
    padding: theme.spacing(2),
    textAlign: "center",
  },
}))

const NotificationsPopover = ({ open, anchorEl, onClose, loading, error, data }) => {
  const classes = useStyles()
  const popoverClasses = usePopoverStyles()
  const [readNotifications] = useMutationReadNotification()

  const id = open ? "notifications-popover" : undefined

  const handleMarkAllRead = async () => {
    if (!data) return
    const ids = data.notifications.items.filter((n) => !n.read).map((n) => n.id)
    if (ids.length) {
      await readNotifications({
        variables: { ids },
      })
    }
  }

  const handleViewAll = () => {
    onClose && onClose()
  }

  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      classes={popoverClasses}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <div className={classes.header}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>Notifications</Grid>
          <Grid item>
            <Button className={classes.linkButton} color="primary" onClick={handleMarkAllRead}>
              Mark all as read
            </Button>
          </Grid>
        </Grid>
      </div>
      <Divider />
      <div className={classes.notifications}>
        <NotificationList {...{ loading, error, data, onNavigate: onClose }} />
      </div>
      <div className={classes.footer}>
        <NavLink to="/notifications" onClick={handleViewAll}>
          <Button className={classes.linkButton} color="primary">
            View all notifications
          </Button>
        </NavLink>
      </div>
    </Popover>
  )
}

export default NotificationsPopover
